import moment from 'moment';

export const IP_CACHE_EXPIRY_TIME = 1000 * 60 * 60;

export async function saveScreenshot(screenshot, name = '', rank, date = new Date()) {
  const filename = `${name}_rank_${rank}_${moment(date).format('YYYYMMDD')}.png`;

  const response = await fetch(screenshot);
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

// URL에서 UTM 파라미터 추출 함수
export const getUtmParameters = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = {};

  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  utmKeys.forEach(key => {
    const value = urlParams.get(key);
    if (value) {
      utmParams[key] = value;
    }
  });

  return utmParams;
};

// IP 정보 가져오기 (비동기)
export const getIpInfo = async () => {
  try {
    const cachedData = localStorage.getItem('ip_info');

    if (cachedData) {
      const { ip, timestamp } = JSON.parse(cachedData);

      const now = Date.now();

      if (now - timestamp < IP_CACHE_EXPIRY_TIME) {
        return ip;
      }
    }

    const response = await fetch('https://ipapi.co/json/');
    const ipData = await response.json();

    if (ipData.ip) {
      localStorage.setItem('ip_info', JSON.stringify({ ip: ipData.ip, timestamp: Date.now() }));
      return ipData.ip;
    }

    return null;
  } catch (error) {
    console.warn('IP 정보를 가져올 수 없습니다:', error);
  }
};

/**
 * Google Tag Manager dataLayer에 이벤트를 전송합니다.
 * @param {...Object} events - 전송할 이벤트 객체들
 * @example
 * pushDataLayer(
 *   { event: 'click', element: 'button' },
 *   { event: 'pageview', page: '/home' }
 * );
 */

export const pushDataLayer = (...events) => {
  for (const event of events) {
    window.dataLayer.push(event);
  }
};

export const getContractStatusText = contract => {
  const { currentState, rewardStatus, first, canceledReason } = contract;

  if (currentState === -3) {
    return '선정완료';
  }

  if (currentState === -2) {
    return '선정대기';
  }

  if (currentState === -1) {
    return canceledReason ? '직접취소' : '이용취소';
  }

  if (currentState === 0) {
    if (rewardStatus === 0) {
      return '구매완료';
    }
    return first === '매장' ? '이용완료' : '신청완료';
  }

  if (currentState === 1) {
    return '리뷰등록';
  }

  if (currentState === 2) {
    return '평가완료';
  }

  return null;
};

export const getChargeType = sumemPoint => {
  if (sumemPoint.contractId) {
    if (sumemPoint.amount > 0) {
      return '소진';
    } else if (sumemPoint.amount < 0) {
      return '환불';
    } else {
      return '-';
    }
  } else {
    if (sumemPoint.pointType === '충전') {
      return '충전';
    } else if (sumemPoint.pointType === '차감') {
      return '차감';
    } else {
      return '-';
    }
  }
};
